import { forwardRef } from "react";

import { cn } from "../../utils/cn";
import { PageHeader } from "../page-header/PageHeader";

import type { HTMLAttributes } from "react";
import type { ForwardRefComponentWithSubcomponents } from "../../utils/types";

export type PageBodyProps = HTMLAttributes<HTMLDivElement>;

export const PageBody = forwardRef<HTMLDivElement, PageBodyProps>(
  ({ className, ...props }, ref) => {
    return (
      <div className={cn("flex flex-col gap-4 px-8 pb-8 pt-4", className)} ref={ref} {...props} />
    );
  }
);
PageBody.displayName = "PageBody";

export type PageProps = HTMLAttributes<HTMLDivElement>;

export const Page = forwardRef<HTMLDivElement, PageProps>(({ className, ...props }, ref) => {
  return <div className={cn("h-full overflow-y-auto", className)} ref={ref} {...props} />;
}) as ForwardRefComponentWithSubcomponents<
  HTMLDivElement,
  {
    Header: typeof PageHeader;
    Body: typeof PageBody;
  },
  PageProps
>;
Page.displayName = "Page";
Page.Header = PageHeader;
Page.Body = PageBody;
